import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsDown20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconThumbsDown20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.968 10.434h.5a1 1 0 0 0 1-1V5.487a1 1 0 0 0-1-1h-.5zm-1.5-5.947H6.467a1 1 0 0 0-.896.554L3.608 8.99a1 1 0 0 0 .895 1.445h4.749l-.14 1.629-.295 3.433 4.586-4.619.065-.065zm-6.146 10.88.167-1.933.129-1.5H4.503c-1.856 0-3.065-1.951-2.238-3.613l1.963-3.948a2.5 2.5 0 0 1 2.239-1.386h9a2.5 2.5 0 0 1 2.5 2.5v3.947a2.5 2.5 0 0 1-2.5 2.5h-1l-4.586 4.619c-.988.995-2.679.211-2.559-1.186"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsDown20);
